import React from 'react';

import classes from './Subtitle.module.scss';

const subtitle = (props) => <p className={classes.Subtitle}>{props.children}</p>;

export default subtitle;